export const encyclopediaJa = {
  // 共通
  'encyclopedia.lockAria': 'ロック済み — ロックを解除して読む',

  // EncyclopediaPage
  'encyclopedia.page.seoTitle': 'エンサイクロペディア',
  'encyclopedia.page.seoDescription':
    'Grymwyrd の生きた魔導書を検索 — モンスター、呪文、種族、アイテム、地域など。',
  'encyclopedia.page.heading': 'エンサイクロペディア',
  'encyclopedia.page.subtitle': 'Grymwyrd のあらゆる恐怖、呪文、伝説の生きた魔導書。',
  'encyclopedia.page.searchPlaceholder': '{plural} を検索…',
  'encyclopedia.page.searchAria': '{plural} を検索',
  'encyclopedia.page.clearSearch': '検索をクリア',
  'encyclopedia.page.systemNotLivePrefix': 'ベール（the Veil）はまだ以下の者に対して開かれていません',
  'encyclopedia.page.systemNotLiveSuffix':
    '。この儀式に結ばれた伝承は流れてきません — その魔導書は暗闇の彼方で待っています。',
  'encyclopedia.page.returnToAllSystems': 'すべてのシステムに戻る',
  'encyclopedia.page.settingNotLivePrefix': '以下の土地',
  'encyclopedia.page.settingNotLiveSuffix':
    'はまだ地図化中です — その項目はまだ設定に結ばれていません。地図作成者が完成するまで、ここでは何も答えません。',
  'encyclopedia.page.returnToAllRealms': 'すべてのレルムに戻る',
  'encyclopedia.page.filteringBy': 'フィルタリング対象',
  'encyclopedia.page.filterSystem': 'システム「{label}」',
  'encyclopedia.page.filterCanon': 'カノンレイヤー「{label}」',
  'encyclopedia.page.filterSetting': '設定「{label}」',
  'encyclopedia.page.canonNote': 'カノンレイヤーは、エンティティが API でタグ付けされると適用されます（_docs/13 を参照）。',
  'encyclopedia.page.clear': 'クリア',
  'encyclopedia.page.hide': '非表示',
  'encyclopedia.page.filter': 'フィルタ',

  // EntityCard
  'encyclopedia.entityCard.unlockAria': '{name} をロック解除（Grymwyrd コンテンツ）',
  'encyclopedia.entityCard.viewAria': '{name} エントリを表示',

  // EntityGrid
  'encyclopedia.grid.paginationAria': 'ページネーション（{position}）',
  'encyclopedia.grid.prev': '前へ',
  'encyclopedia.grid.next': '次へ',
  'encyclopedia.grid.pageOf': 'ページ {page} / {totalPages}',
  'encyclopedia.grid.resultsAria': '{plural} 件の結果',
  'encyclopedia.grid.scrying': 'アーカイブをスクライ中…',
  'encyclopedia.grid.count': '{total} 個の {plural}',
  'encyclopedia.grid.sortDescAria': '降順でソート',
  'encyclopedia.grid.sortAscAria': '昇順でソート',
  'encyclopedia.grid.sortAZ': 'A–Z',
  'encyclopedia.grid.sortZA': 'Z–A',
  'encyclopedia.grid.viewModeAria': '表示モード',
  'encyclopedia.grid.gridViewAria': 'グリッドビュー',
  'encyclopedia.grid.listViewAria': 'リストビュー',
  'encyclopedia.grid.jumpToLetterAria': '文字にジャンプ',
  'encyclopedia.grid.all': 'すべて',
  'encyclopedia.grid.letterSymbolAria': '数字または記号で始まるエントリ',
  'encyclopedia.grid.letterAria': '{letter} で始まるエントリ',
  'encyclopedia.grid.emptyTitle': 'アーカイブは静かだ',
  'encyclopedia.grid.emptyForLetter': '「{letter}」で始まる名前の {plural} はありません。',
  'encyclopedia.grid.emptyAll': 'あなたの呼びに応じる {plural} はありません。',
  'encyclopedia.grid.turningPages': 'ページをめくり中…',

  // EntityImage
  'encyclopedia.entityImage.noArtworkAria': '{label}（アートワークなし）',
  'encyclopedia.entityImage.noVision': 'ビジョンなし',

  // FacetSidebar
  'encyclopedia.facets.all': 'すべて',
  'encyclopedia.facets.soon': 'まもなく',
  'encyclopedia.facets.navAria': 'エンティティタイプフィルタ',
  'encyclopedia.facets.clearAll': 'すべてのフィルタをクリア',
  'encyclopedia.facets.lorebook': 'ロアブック',
  'encyclopedia.facets.gameSystem': 'ゲームシステム',
  'encyclopedia.facets.canonLayer': 'カノンレイヤー',
  'encyclopedia.facets.setting': '設定',

  // GlobalSearch
  'encyclopedia.globalSearch.title': 'ベール（the Veil）を検索',
  'encyclopedia.globalSearch.placeholder': 'モンスター、呪文、地域、伝承を検索…',
  'encyclopedia.globalSearch.queryAria': '検索クエリ',
  'encyclopedia.globalSearch.loading': 'スクライ中…',
  'encyclopedia.globalSearch.empty': '「{q}」の暗闇には何も蠢きません。',

  // LockedContent — LockBadge
  'encyclopedia.lockBadge.title': 'Grymwyrd コンテンツ — ロックを解除して読む',
  'encyclopedia.lockBadge.label': 'ロック済み',
  // LockedContent — LockedGate
  'encyclopedia.lockedGate.regionAria': 'ロック済みコンテンツ',
  'encyclopedia.lockedGate.defaultTitle': 'この伝承は封印されている',
  'encyclopedia.lockedGate.body':
    'Grymwyrd 自身の獣図鑑、呪文、伝説は Grymwyrd Cataclysm に結ばれています。オープン SRD カノンは無料のままです — ですが、永遠のトワイライト（the eternal twilight）そのものを歩むには、本を手に入れてください。',
  'encyclopedia.lockedGate.unlockCta': 'Grymwyrd をロック解除',
  'encyclopedia.lockedGate.signInCta': 'すでにバッカー？ サインイン',
  'encyclopedia.lockedGate.backerNote':
    'Grymwyrd にプレッジしたバッカーはすでにこれを所有しています — サインインしてあなたのアカウントでロック解除してください。',

  // TableView
  'encyclopedia.table.rollToastTitle': '{name} — {total} をロール',
  'encyclopedia.table.noRowMatched': '{total} に一致する行がありません。',
  'encyclopedia.table.loading': 'テーブルを広げ中…',
  'encyclopedia.table.error': 'このテーブルを描画できませんでした。',
  'encyclopedia.table.roll': '{formula} をロール',
  'encyclopedia.table.lastRoll': '最後のロール: {value}',
  'encyclopedia.table.noMatchingRow': ' · 一致する行なし',

  // EntityDetailPage
  'encyclopedia.detail.entryFallback': 'エントリ',
  'encyclopedia.detail.addedToCampaign': 'キャンペーンに追加されました。',
  'encyclopedia.detail.addError': 'キャンペーン保管庫に到達できませんでした。後でもう一度お試しください。',
  'encyclopedia.detail.unknownType': '不明なエントリタイプです。',
  'encyclopedia.detail.seoDescription': '{name} — Grymwyrd エンサイクロペディア内の {label}。',
  'encyclopedia.detail.breadcrumbAria': 'ブレッドクラムb',
  'encyclopedia.detail.breadcrumbRoot': 'エンサイクロペディア',
  'encyclopedia.detail.sourceVersionAria': 'ソースバージョン',
  'encyclopedia.detail.versionConsolidated': '統合版',
  'encyclopedia.detail.versionBook': '特定の本',
  'encyclopedia.detail.removeBookmarkAria': 'ブックマークを削除',
  'encyclopedia.detail.addBookmarkAria': 'ブックマークを追加',
  'encyclopedia.detail.bookmarked': 'ブックマーク済み',
  'encyclopedia.detail.bookmark': 'ブックマーク',
  'encyclopedia.detail.addToCampaign': 'キャンペーンに追加',
  'encyclopedia.detail.sealedTitle': '{name} は封印されている',
  'encyclopedia.detail.bookVariantNote':
    '統合レコードを表示中です。本版の異なるテキストは、本版がリンクされると、ここに表示されます。',
  'encyclopedia.detail.tablistAria': 'エントリセクション',
  'encyclopedia.detail.tab.lore': '伝承',
  'encyclopedia.detail.tab.stats': 'ステータス',
  'encyclopedia.detail.tab.gallery': 'ギャラリー',
  'encyclopedia.detail.tab.relations': '関連',
  'encyclopedia.detail.tab.discussions': 'ディスカッション',
  'encyclopedia.detail.tab.claims': 'プレイヤークレーム',
  'encyclopedia.detail.loading': 'エントリを起動中…',

  // tabs/LoreTab
  'encyclopedia.lore.loading': '伝承を掘り起こし中…',
  'encyclopedia.lore.empty': 'このエントリの歴史はまだ書かれていません。',

  // tabs/StatsTab
  'encyclopedia.stats.loading': 'ルーン（the runes）を読み中…',
  'encyclopedia.stats.empty': 'このエントリについて記録されたメカニクスはありません。',

  // tabs/GalleryTab
  'encyclopedia.gallery.loading': 'ビジョンを現像中…',
  'encyclopedia.gallery.emptyTitle': 'まだビジョンなし',
  'encyclopedia.gallery.emptyBody': 'アートワークはこのエントリに結ばれていません。Vault 内で1つ貢献してください。',
  'encyclopedia.gallery.artworkAlt': 'エンティティアートワーク',

  // tabs/DiscussionsTab
  'encyclopedia.discussions.loading': 'ささやきを集め中…',
  'encyclopedia.discussions.emptyTitle': 'ホールの沈黙',
  'encyclopedia.discussions.emptyBody': '同じ放浪者とこのエントリについて議論する最初の者になってください。',
  'encyclopedia.discussions.startCta': 'ディスカッションを開始',
  'encyclopedia.discussions.untitledThread': 'タイトルなしスレッド',
  'encyclopedia.discussions.byAuthor': '{author} による',
  'encyclopedia.discussions.replyCount': '{count} 件の返信',

  // tabs/ClaimsTab
  'encyclopedia.claims.recorded': 'あなたのクレームはレビュー用に記録されました。',
  'encyclopedia.claims.recordError': '筆記者はあなたのクレームを記録できませんでした。後でもう一度お試しください。',
  'encyclopedia.claims.loading': 'カノンを相談中…',
  'encyclopedia.claims.emptyTitle': 'プレイヤークレームはまだなし',
  'encyclopedia.claims.emptyBody': 'まだどの放浪者もこのエントリに彼らの伝説を織り込んでいません。',
  'encyclopedia.claims.claimCta': 'これをクレーム',
  'encyclopedia.claims.signInCta': 'サインインしてクレームを主張',
  'encyclopedia.claims.untitledClaim': 'タイトルなしクレーム',
  'encyclopedia.claims.byAuthor': '{author} による',
  'encyclopedia.claims.addCta': 'あなたのクレームを追加',

  // tabs/RelationsTab
  'encyclopedia.relations.thisEntry': 'このエントリ',
  'encyclopedia.relations.relationLabel': '関連 {index}',
  'encyclopedia.relations.kindredLabel': 'キンドレッド {index}',
  'encyclopedia.relations.loading': '運命の糸をトレース中…',
  'encyclopedia.relations.hintIntro': 'ノードをクリックしてそのエントリに移動します。表示されるスレッドは',
  'encyclopedia.relations.hintCanonical': 'カノンの関連です。',
  'encyclopedia.relations.hintKindred': '同じタイプのキンドレッドです。',
} as const
